module.exports = __webpack_public_path__ + "media/src/assets/images/reception-077b82466cb74270a457e08c6f084048.svg";